module.exports = __webpack_public_path__ + "static/js/unsubscriptions.1b5f16d8.chunk.worker.js"